import styled from 'styled-components';

// Shared by ChoiceList and CheckboxChoice. The 28px indent clears the control and happens to be the
// same for both: a radio is ~13px plus @ixicare/ui's 15px right margin, a checkbox is a 16px box
// with a 2px border either side plus an 8px margin. Kept in one place so the two cannot drift.

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Option = styled.div`
  /* Only the control's own label — never labels inside the revealed content, which keep
     whatever styling their own control gives them. */
  > div:first-child label {
    font-family: Poppins;
    font-weight: 600;
    color: var(--midnight-blue);
    cursor: pointer;
  }
`;

export const Description = styled.label`
  display: block;
  margin: 2px 0 0 28px;
  font-family: Poppins;
  font-size: 13px;
  color: var(--comet);
  cursor: pointer;
`;

export const Reveal = styled.div`
  margin: 12px 0 0 28px;
`;
